/**
 * AppBottomNav - mobile bottom navigation
 */
import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileEdit, CalendarDays, BarChart3, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import AppSidebar from "./AppSidebar";

const BOTTOM = [
    { to: "/painel", label: "Painel", icon: LayoutDashboard, testid: "bottom-dashboard" },
    { to: "/publicacoes", label: "Posts", icon: FileEdit, testid: "bottom-posts" },
    { to: "/calendario", label: "Calendário", icon: CalendarDays, testid: "bottom-calendar" },
    { to: "/relatorios", label: "Relatórios", icon: BarChart3, testid: "bottom-reports" },
];

export default function AppBottomNav() {
    return (
        <nav
            className="lg:hidden fixed bottom-0 left-0 right-0 z-30 border-t border-border bg-background/95 backdrop-blur-md"
            data-testid="app-bottom-nav"
        >
            <div className="grid grid-cols-5 px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
                {BOTTOM.map((it) => {
                    const Icon = it.icon;
                    return (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            className={({ isActive }) =>
                                `flex flex-col items-center gap-0.5 py-2 rounded-lg ${
                                    isActive ? "text-[#A78BFA]" : "text-muted-foreground"
                                }`
                            }
                            data-testid={it.testid}
                        >
                            <Icon className="h-5 w-5" />
                            <span className="text-[10px] font-medium">{it.label}</span>
                        </NavLink>
                    );
                })}
                <Sheet>
                    <SheetTrigger asChild>
                        <button
                            className="flex flex-col items-center gap-0.5 py-2 rounded-lg text-muted-foreground"
                            data-testid="bottom-more"
                        >
                            <Menu className="h-5 w-5" />
                            <span className="text-[10px] font-medium">Mais</span>
                        </button>
                    </SheetTrigger>
                    <SheetContent side="left" className="p-0 w-[280px] dark bg-background">
                        <div className="dark min-h-full bg-background">
                            <AppSidebar />
                        </div>
                    </SheetContent>
                </Sheet>
            </div>
        </nav>
    );
}
